import {Pipe, PipeTransform} from "@angular/core";
import {StripeRequirements} from "../consts/StripeRequirements";

@Pipe({
  name: 'stripeRequirement'
})
export class StripeRequirementPipe implements PipeTransform {
  public transform(requirementCode: string): string {

    let requirement = StripeRequirements.find((requirementP) =>
      requirementP.code.toLowerCase() === requirementCode.toLowerCase()
    );

    if (!requirement) {
      return "Unknown requirement";
    }

    return requirement.requirement;
  }
}
